import React from 'react'
import FormReducer from '../commons/FormReducer'
import { formFieldRemove, formFieldsValue } from '../commons/FormReducer/action'
import actionTarget from '../commons/Redux/actionTarget'
import View from './view'

export class PssDemo extends React.Component {

    constructor(props) {
        super(props)
        this.state = { open: false }
        this.onClickReset = this.onClickReset.bind(this)
        this.onClickOpenDialog = this.onClickOpenDialog.bind(this)
    }

    componentDidMount() {
        this.onClickReset()
    }

    onClickOpenDialog() {

    }

    onClickReset() {
        console.log('reset')

        const {
            dispatch,
            storeTargetForm
        } = this.props
        dispatch(actionTarget(formFieldRemove(), storeTargetForm))
    }

    render() {
        const {
            fetchProps,
            storeTargetForm,
            ...props
        } = this.props
        console.log('TestFetch', this.props)
        return (
            <FormReducer storeTarget={storeTargetForm} keepState>
                <View
                    {...props}
                    onClickReset={this.onClickReset}
                    onClickOpenDialog={this.onClickOpenDialog}
                />
            </FormReducer>
        )
    }
}